<template>
  <div>
    <span>{{priceBox.currency}}</span>
    <br>
    <!-- <el-input
      placeholder="Please input"
      v-model="priceBox.price"
      style="width:30%"
    >
    </el-input> -->
    <money-box :fixed="this.fraction"
        v-model="priceBox.price"
        style="width:30%">
    </money-box>
  </div>
</template>

<script>
import Money from './money'

export default {
    props: ['priceBox', 'fraction'],
    methods: {
        // numberWithCommas (digital, place) {
        //     let digitalFixed = Number.parseFloat(digital).toFixed(place)
        //     return digitalFixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        // },
        // numberNoCommas (commasDigital) {
        //     if (commasDigital === '') return 0
        //     return parseFloat(commasDigital.replace(/,/g, ''))
        // }
        // setPriceVal (val) {
        //     this.priceBox.price = this.numberNoCommas(val)
        // }
    },
    components: {
        'money-box': Money
    }
}
</script>
